import { NOTATION_PROVIDER_CONSTRUCTOR_ROLE } from './consts';
export class NotationProviderBase {
    /** Name of the custom notation */
    static get notationName() {
        return 'Custom';
    }
    ;
    /** flag to let bio know if this provider implements method for converting helm to it */
    static get implementsFromHelm() {
        return false;
    }
    ;
    /** Method for converting HELM to this notation */
    static convertFromHelm(helm, options) {
        throw new Error(`Method convertFromHelm not implemented for this notation provider`);
    }
    ;
    static async getProviderConstructors() {
        // this is terrible, I know, but otherwise this gets put in webworkers and fails due to DG resolution)))
        // @ts-ignore
        if (window?.DG) {
            // @ts-ignore
            const constFuncs = window.DG.Func.find({ meta: { role: NOTATION_PROVIDER_CONSTRUCTOR_ROLE } });
            return Promise.all(constFuncs.map((f) => f.apply({})));
        }
        return [];
    }
}
/** Alphabet candidate type */
export class CandidateType {
    constructor(name, alphabet, cutoff) {
        this.name = name;
        this.alphabet = alphabet;
        this.cutoff = cutoff;
    }
}
/** Alphabet candidate similarity type */
export class CandidateSimType extends CandidateType {
    constructor(candidate, freq, similarity) {
        super(candidate.name, candidate.alphabet, candidate.cutoff);
        this.freq = freq;
        this.similarity = similarity;
    }
}
//# sourceMappingURL=types.js.map